import html from '@nexa/content/legal/cookies.vi.html?raw';
import LegalDocPage from './LegalDocPage.tsx';

/**
 * Wrapper MỘT LOCALE cho `legal-cookies`.
 *
 * ⛔ Đừng gộp hai locale vào một module, đừng đổi sang `import()` động, đừng gom qua
 * barrel, đừng bỏ `html` để dùng lại DOM đã prerender. Lý lẽ đầy đủ và số đo giữ ở MỘT
 * chỗ — `core/router/pageModules.ts` — để nó không trôi ở 14 bản sao (vé #39).
 *
 * Bốn trục nối của file này (tên file · `htmlLocale` · locale trong `?raw` · `pageId`)
 * do `core/router/pageModules.test.ts` canh tĩnh.
 */
export default function CookiesPageVi() {
  return <LegalDocPage pageId="legal-cookies" htmlLocale="vi" html={html} />;
}
